import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=2d814948&scoped=true"
import script from "./ContextMenu.vue?vue&type=script&lang=js"
export * from "./ContextMenu.vue?vue&type=script&lang=js"
import style0 from "./ContextMenu.vue?vue&type=style&index=0&id=2d814948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../hotel-wc-product/hotel-wc/sources/client/hotel-wc-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d814948",
  null
  
)

export default component.exports